import { featuredArticles } from '@/mocks/zh/article';

export default function LatestReveal() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新爆料
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时追踪全网最新黑料动态</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-300"
            >
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2.5 py-1 bg-accent-500 text-foreground-950 text-xs font-semibold rounded-full">
                    {article.categoryName}
                  </span>
                  {article.isNew && (
                    <span className="px-2 py-0.5 bg-secondary-500 text-background-50 text-[10px] font-bold rounded">NEW</span>
                  )}
                  {article.isHot && (
                    <span className="px-2 py-0.5 bg-red-500 text-background-50 text-[10px] font-bold rounded">HOT</span>
                  )}
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug line-clamp-2 mb-3 group-hover:text-accent-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                    <span><i className="ri-eye-line mr-1"></i>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(0)}万`
                        : article.views}
                    </span>
                  </div>
                  <span className="text-xs font-medium text-accent-600 whitespace-nowrap group-hover:translate-x-1 transition-transform inline-flex items-center gap-0.5">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}